import * as Yup from 'yup';

import strings from 'strings';

export const MINIMUM_PASSWORD_LENGTH = 12;
const LEGACY_MINIMUM_PASSWORD_LENGTH = 8;

export const newPasswordSchema = () => Yup.string().min(MINIMUM_PASSWORD_LENGTH, strings.validation.passwordLength);

export const currentPasswordSchema = () =>
  Yup.string().min(LEGACY_MINIMUM_PASSWORD_LENGTH, strings.validation.currentPasswordLength);
